import { render, staticRenderFns } from "./SplashDerechos.vue?vue&type=template&id=e934a244&scoped=true&"
import script from "./SplashDerechos.vue?vue&type=script&lang=js&"
export * from "./SplashDerechos.vue?vue&type=script&lang=js&"
import style0 from "./SplashDerechos.vue?vue&type=style&index=0&id=e934a244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e934a244",
  null
  
)

export default component.exports